import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SkillSummary.css';

const DEFAULT_API_URL =
  typeof window !== 'undefined' && window.location.hostname.includes('localhost')
    ? 'http://localhost:5000/api'
    : 'https://vet-career-translator.onrender.com/api';

const API_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).trim();

function SkillSummary({ selectedSkills }) {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedSkills.length > 0) {
      fetchSummary();
    }
  }, [selectedSkills]);

  const fetchSummary = async () => {
    try {
      const response = await axios.post(`${API_URL}/skills-summary`, {
        skill_ids: selectedSkills
      });
      setSummary(response.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !summary) {
    return <div>Loading summary...</div>;
  }

  return (
    <div className="skill-summary">
      <div className="summary-section">
        <h3>Selected Military Skills</h3>
        <div className="skill-list">
          {summary.selected_skills.map(skill => (
            <div key={skill.id} className="summary-skill">
              <span className="skill-badge">{skill.military_term}</span>
              <span className="translations">
                {skill.civilian_translations.join(', ')}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="summary-section">
        <h3>Core Competencies</h3>
        <div className="competencies">
          {summary.aggregated_skills.map(([skill, count]) => (
            <div key={skill} className="competency">
              <span className="competency-name">{skill}</span>
              <span className="competency-count">({count})</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SkillSummary;
